import { Component, OnInit, OnChanges, Input, ViewChild, SimpleChanges, OnDestroy } from '@angular/core';
import { Table } from 'primeng-lts/table';
import { environment } from 'src/environments/environment';
import { Subscription, } from 'rxjs';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { ReportPayload } from '../../models/report-payload';
import { ReportTableRow, ReportTableColumn, ReportTableType } from '../../models/report-table';
import { EvaluationCriteriaService } from 'src/app/events/services/evaluation-criteria.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ReportType } from '../../models/report-types';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChecklistEventService } from 'src/app/events/services/checklist-event.service';
import { ReportService } from '../../services/report.service';
import { ReportFormatterService } from '../../services/report-formatter.service';
import { ReportExportService } from '../../services/report-export.service';
import { VehicleEntry } from '../../models/report-viewers';
import { cleanKmLabel } from '../../helpers/cleanKmLabel';

@Component({
  selector: 'app-report-table',
  templateUrl: './report-table.component.html',
  styleUrls: ['./report-table.component.scss']
})
export class ReportTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() sortColumns: boolean = true;
  @Input() scrollHeight: string = '700px';
  @Input() rows!: ReportTableRow[];
  @Input() columns!: ReportTableColumn[];
  @Input() type : ReportTableType = ReportTableType.PAGINATOR;
  @Input() report! : ReportPayload;
  @Input() imei : string | undefined = "";
  @Input() vehicleName : string | undefined = undefined;
  @Input() virtualRowHeight : number= 34;
  @Input() applyStripedColor = true; // pintar las filas striped colors

  // control especial
  @Input() withButtonGeneral : boolean = false;
  @Input() withButtonDriversList : boolean = false;


  public customMessageUpdateListaDriver?: string = undefined;
  public customMessageErrorListaDriver? : string = undefined;

  public rowByPageDefault = 15;

  public totalRecords : any = 0;
  @ViewChild('dt') dt!: Table;

  private cacheSubscription?: Subscription;
  private showImagesSubscription?: Subscription;

  public rowReportGeneralAll? : VehicleEntry;

  public showAll = false;
  public withShowAll = false;
  public loading = false;

  public globalFilterFields : string[] = []
  public TableType = ReportTableType;

  public dialogTitle = "Todos";


  // OPTIONS
  public driverKeyCipia : any[] = []

  constructor(
    private evaluationCriteriaService : EvaluationCriteriaService,
    private reportFormatter : ReportFormatterService,
    private spinner : NgxSpinnerService,
    private checklitEvent : ChecklistEventService,
    private reportService : ReportService,
    private http:HttpClient,
    private reportExport : ReportExportService
  ) {

  }
  onShowAll() {
    this.showAll = true; // abre el diálogo
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['report']) {
      this.updateTable(); // o lo que necesites ejecutar
    }
  }
  ngOnInit(): void {
    this.dialogTitle = `VEHÍCULO ${this.vehicleName} - PERIODO ${this.report.reportDetails.periodRange}`;
    if(this.report.reportDetails.reportType == ReportType.REPORTE_ATENCION_EVENTOS ){
      this.http.get(`${environment.apiUrl}/api/driverDataAll`).toPromise().then((response : any) => {
        this.driverKeyCipia = response.data[0].filter((driver : any) => !!driver.id_keyIcipia);
      });
    }
  }
  exportReport(format : string) {
    if(format == "excel"){
      this.reportExport.exportReportRecordsToExcel(this.report, this.rowReportGeneralAll?.records || [], this.vehicleName, this.rowReportGeneralAll?.summary)
    }
    if(format == "html"){
      this.reportExport.exportReportRecordsToHtml(this.report, this.rowReportGeneralAll?.records || [], this.vehicleName, this.rowReportGeneralAll?.summary)
    }
    if(format == "pdf"){
      this.reportExport.exportReportRecordsToPdf(this.report, this.rowReportGeneralAll?.records || [], this.vehicleName, this.rowReportGeneralAll?.summary)
    }
  }
  ngOnDestroy(): void {
    this.cacheSubscription?.unsubscribe();
    this.showImagesSubscription?.unsubscribe();
  }
  onDialogClosed() {
    this.globalFilterFields = []
  }
  public updateTable() {
    this.rowByPageDefault = 15;
    this.sortColumns = true;
    this.totalRecords = 0;
    this.rowReportGeneralAll = undefined
    this.globalFilterFields = []
    this.imageCache = {}
    this.dt?.reset();
    this.columns = this.columns.filter(c => !!c);
    this.columns.forEach(col => {
      if (col && (col.type === 'text' || col.type === 'date')) {
        this.globalFilterFields.push(col.field);
      }
    })
    this.withShowAll = false;
    const type = this.report.reportDetails.reportType;
    if (this.report) {
      switch (type) {
        case ReportType.REPORTE_EXCESOS_VELOCIDAD_LIMITE_PERSONALIZADO:
          this.virtualRowHeight = 34;
          break;
        case ReportType.REPORTE_CHECKLIST:
          this.type = ReportTableType.PAGINATOR;
          this.checklitEvent.loadImageFromChecklist(this.report);
          break;
        case ReportType.REPORTE_GENERAL:
          this.withShowAll = true;
          break;
        case ReportType.REPORTE_CONDUCTORES_ENROLADOS:
          this.rowByPageDefault = 30;
          break;
        case ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_DURACION_TOLERANCIA_NIVEL_RIESGO:
        case ReportType.REPORTE_EXCESOS_VELOCIDAD_DURACION_TOLERANCIA_NIVEL_RIESGO:
        case ReportType.REPORTE_EXCESOS_VELOCIDAD_POR_NIVEL:
          this.applyStripedColor = false;
          let count = this.rows[this.rows.length - 1];
          if(count){
            this.totalRecords = count.itemResumen;
            this.sortColumns = false;
          }
          break;
        default:
          this.withShowAll = false;
          break
      }
    }



    if(type == ReportType.REPORTE_CHECKLIST){
      this.cacheSubscription = this.checklitEvent.cache$.subscribe(images => {
        this.imageCache = images as any;
      });

      this.showImagesSubscription = this.reportService.currentShowImagesChecklist.subscribe(show => {
        this.toggleImageColumn(show);
      })
    }
  }

  public toggleImageColumn(show : boolean) {
    this.columns.find(c => c.field === 'previsualizacion')!.hidden = !show;
  }
  // UTIL
  public showColumn(field: keyof ReportTableRow): boolean {
    return this.rows.some(row => {
      const value = row[field];
      return value !== null && value !== undefined;
    });
  }

  // criterios de evaluacion
  getCriterioEvaluationOptionsForRow(evento : any){
    return this.evaluationCriteriaService.getOptionBySlug(evento);
  }
  onDriverIdentificationChange(driverId: any, row : any) {
    if(driverId.value){
      row.isUnknownDriver = false
    }
    row.newDriverId = driverId.value
    row.editado = 'si';
  }
  onDriverUnknownChange(event: any, row : any) {
    if(event.checked){
      row.newDriverId = null
    }
    row.isUnknownDriver = event.checked
    row.editado = 'si';
  }
  onChangeCriterioEvaluacion(event : any,row:any) {
    row.criterioId = event.value;
    row.isConfirmed = this.evaluationCriteriaService.isCriteriaConfirmed(event.value);
    let criterioSelected = this.evaluationCriteriaService.getById(event.value)
    if(criterioSelected){
      row.criterioEvaluacion = criterioSelected.name;
    }
    if (row.fechaEvaluacion == "" || row.fechaEvaluacion == null || row.fechaEvaluacion == "-") {
      row.fechaEvaluacion = moment(new Date()).format("YYYY/MM/DD"); //actualizar = true;
      row.horaEvaluacion = moment(new Date()).format("HH:mm:ss"); //actualizar = true;
    }
    row.senalesPosibleFatiga = this.evaluationCriteriaService.isPosibleFatiga(event.value);

    row.es_antiguo_criterio = false;
    row.editado = 'si';
  }
  onChangeObservacion(row:any) {
    if (row.fechaEvaluacion == "" || row.fechaEvaluacion == null) {
      row.fechaEvaluacion = moment(new Date()).format("YYYY/MM/DD"); //actualizar = true;
      row.horaEvaluacion = moment(new Date()).format("HH:mm:ss"); //actualizar = true;
    }
    row.editado = 'si';
  }
  onChangeOperadorMonitoreo(row:any) {
    if (row.fechaEvaluacion == "" || row.fechaEvaluacion == null) {
      row.fechaEvaluacion = moment(new Date()).format("YYYY/MM/DD"); //actualizar = true;
      row.horaEvaluacion = moment(new Date()).format("HH:mm:ss"); //actualizar = true;
    }
    row.editado = 'si';
  }

  // carga de imagenes de checklist
  public imageCache: { [key: string]: {
    blob: Blob | null;
    objectUrl: string;
    safeUrl: SafeUrl | string;
    isLoading: boolean;
    hasError: boolean;
  } } = {};
  public imageChecklistLoaded = false;

  // [ngClass]="{'highlight-driver': isDriverHighlighted(row)}"
  isDriverHighlighted(row: any): boolean {
    return row.datosChecklist?.some((c : any) => c.name_driver === row.conductor) ?? false;
  }


  public sanitizeKm(value: any): any {
    return cleanKmLabel(value)
  }

  get operadorMonitoreoOptions(): { label: string; value: string }[] {
    if (!this.report?.operators) return [{ label: 'OTRO', value: 'OTRO' }];
    return [...this.report.operators, { label: 'OTRO', value: 'OTRO' }];
  }

  verTodosGeneral() {
    this.spinner.show("reportSpinner");
    let dataParam = this.report.systemParams;
    dataParam['limit'] = false;
    dataParam['findImei'] = this.imei;

    this.http.post(environment.apiUrl + dataParam.url, dataParam).subscribe({
      next: data => {
        this.spinner.hide("reportSpinner");

        let recordGeneral = this.reportFormatter.formatRecordsReportGeneral(data, this.report.filters )
        this.rowReportGeneralAll = recordGeneral
        this.onShowAll();
      }
    });

  }

// ESPECIAL CONTROLS
  async updateDriversList() {
    console.log("report : update driver list to report", this.imei, this.vehicleName)
    this.customMessageUpdateListaDriver = undefined;
    this.customMessageErrorListaDriver = undefined;
    if(!this.imei)return;
    this.loading = true;
    let driversList = await this.reportService.getDriverListReportDriverReport(this.imei, this.vehicleName || "-")
    if(driversList){
      if(driversList.length == 0){
        this.customMessageUpdateListaDriver = "Se obtubo una lista de conductores vacia"
      }else{
        this.customMessageUpdateListaDriver = "La lista de conductores se obtuvo correctamente."
      }
      if (this.rows) {
        this.rows.length = 0;            // 🔹 vacías el array existente
        this.rows.push(...driversList);  // 🔹 añades los nuevos elementos
      }
    }else {
      console.log("error al obtener lista de condutores")
      this.customMessageErrorListaDriver = "No pudimos actualizar la lista de conductores. Inténtalo nuevamente mas tarde."
    }
    this.loading = false;
    console.log("report : show the driver list", driversList)
    // if(!this.vehicleData)return
    // this.vehicleData.vehicles = this.vehicleData.vehicles.map(vehicleEntry => {
    //   if (vehicleEntry.vehicle.imei === imei) {
    //     return {
    //       ...vehicleEntry,
    //       records: driversList
    //     }
    //   }
    //   return vehicleEntry
    // })
  }
}
